import { render, staticRenderFns } from "./group.vue?vue&type=template&id=f6af0652&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=f6af0652&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af0652",
  null
  
)

export default component.exports